module.exports = __webpack_public_path__ + "static/media/harley_dykstra_home.2c7ab9a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Media/harley_dykstra_home.jpg
// module id = 496
// module chunks = 0